import { render } from "./ClaimForm.vue?vue&type=template&id=28846fd3&ts=true"
import script from "./ClaimForm.vue?vue&type=script&lang=ts"
export * from "./ClaimForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__